<template>
  <transition enter-active-class='animated animated3 fadeInDown' leave-active-class='animated animated3 fadeOutUp'>
    <div class="alert message-wrap" :class='alertClass' role="alert" v-if="visible">
      <span v-html="alertIcon"></span> {{content}}
    </div>
  </transition>
</template>

<script>

    export default {
      props:{
        content:{
          type:String,
          default:'默认信息xxxxxxxx'
        },
        type:{
          type:String,
          default:'success'
        }
      },
      computed:{
        alertClass(){
          return 'alert-'+this.type;
        },
        alertIcon(){
          switch(this.type) {
            case 'success':
              return "<i style='color:#009933;' class='glyphicon glyphicon-ok-sign'></i>"; break;
            case 'info':
              return '<i style="color:#F2A231;" class="glyphicon glyphicon-ok-sign"></i>'; break;
            case 'warning':
              return '<i style="color:#F2A231;" class="glyphicon glyphicon-info-sign"></i>'; break;
            case 'danger':
              return '<i style="color:#D8403E;" class="glyphicon glyphicon-remove-sign"></i>'; break;
            default:
              return '未知操作';
          } 
        }
      },
      data(){
        return {
          visible:false
        }
      },
      methods:{
        startTimer(){
          window.setTimeout(() => {
            this.visible = false;
          }, 3000);
        }
      },
      mounted(){
        this.startTimer();
      }
    }

</script>

<style scoped lang='less'>
  .message-wrap {
    position: fixed;
    margin:auto;
    left:0;
    right:0;
    top:0;
    display: inline-block;
    top: 25px;
    z-index: 9;
    text-align:center;
    width:220px;

    letter-spacing:2px;

    padding: 16px 24px;
    border: 0;
    background: #fff;
    -webkit-box-shadow: 0 4px 16px 0 rgba(0,0,0,.2);
    box-shadow: 0 4px 16px 0 rgba(0,0,0,.2);
    border-radius: 4px;
    font-size: 14px;
    color:#333B44;

  }
  .animated1 {
      animation-duration: 0.1s;
      animation-fill-mode: both;
  }
  .animated2 {
      animation-duration: 0.2s;
      animation-fill-mode: both;
  }
  .animated3 {
      animation-duration: 0.3s;
      animation-fill-mode: both;
  }
</style>


// WEBPACK FOOTER //
// src/components/common/message/index.vue